export default {
  metadata: {
    version: '1.0.0',
    id: 'input-date-1.0.0',
    name: 'JDSInputDate',
    description: '',
    usage:
      'Input date component is used to help users enter a memorable date or one they can easily look up for example a date of birth or an expiration date of the credit card.'
  },
  hierarchy: {
    container: [
      {
        'outer-container': [
          {
            'field-container': [
              'label-jds-text',
              {
                'input-container': [
                  {
                    'dd-container': [
                      'dd-jds_input',
                      {
                        'dd-active-line-container': ['dd-feedback-container']
                      }
                    ]
                  },
                  'left-slash-container',
                  {
                    'mm-container': [
                      'mm-jds_input',
                      {
                        'mm-active-line-container': ['mm-feedback-container']
                      }
                    ]
                  },
                  'right-slash-container',
                  {
                    'yy-container': [
                      'yy-jds_input',
                      {
                        'yy-active-line-container': ['yy-feedback-container']
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            'calendar-container': ['calendar-jds_action_button']
          }
        ]
      },
      'jds_feedback_block',
      'helper-jds-text',
      'jds_datepicker'
    ]
  },
  base: {
    container: {
      'flex-direction': '{i_0}',
      'align-items': '{i_1}',
      gap: '{i_2}',
      width: '{i_3}'
    },
    'outer-container': {
      'flex-direction': '{i_4}',
      width: '{i_5}',
      'align-items': '{i_6}'
    },
    'field-container': {
      flex: 1,
      'flex-direction': '{i_7}',
      width: '{i_8}',
      'align-items': '{i_9}'
    },
    'input-container': {
      width: '{i_10}',
      gap: '{i_11}',
      height: 36,
      'align-items': '{i_12}'
    },
    'dd-container': {
      'flex-direction': '{i_13}',
      flex: 1,
      gap: '{i_14}',
      'align-items': '{i_15}'
    },
    'dd-jds_input': {
      disabled: false,
      type: 'number',
      textAlign: '{i_16}',
      maxLength: 2,
      placeholder: 'dd'
    },
    'dd-active-line-container': {
      width: '{i_17}',
      'padding-top': 1,
      'padding-bottom': 1
    },
    'dd-feedback-container': {
      height: 2,
      width: '{i_18}',
      'background-color': '{i_19}',
      show: true
    },
    'left-slash-container': {
      width: 1,
      height: 35,
      rotate: 10,
      'background-color': '{i_20}',
      show: true
    },
    'mm-container': {
      'flex-direction': '{i_21}',
      flex: 1,
      gap: '{i_22}',
      'align-items': '{i_23}'
    },
    'mm-jds_input': {
      disabled: false,
      type: 'number',
      textAlign: '{i_24}',
      maxLength: 2,
      placeholder: 'mm'
    },
    'mm-active-line-container': {
      width: '{i_25}',
      'padding-top': 1,
      'padding-bottom': 1
    },
    'mm-feedback-container': {
      height: 2,
      width: '{i_26}',
      'background-color': '{i_27}',
      show: true
    },
    'right-slash-container': {
      width: 1,
      height: 35,
      rotate: 10,
      'background-color': '{i_28}',
      show: true
    },
    'yy-container': {
      'flex-direction': '{i_29}',
      flex: 1,
      gap: '{i_30}',
      'align-items': '{i_31}'
    },
    'yy-jds_input': {
      disabled: false,
      type: 'number',
      textAlign: '{i_32}',
      maxLength: 4,
      placeholder: 'yyyy'
    },
    'yy-active-line-container': {
      width: '{i_33}',
      'padding-top': 1,
      'padding-bottom': 1
    },
    'yy-feedback-container': {
      height: 2,
      width: '{i_34}',
      'background-color': '{i_35}',
      show: true
    },
    'calendar-container': {
      hidden: false,
      'justify-content': '{i_36}',
      'align-items': '{i_37}'
    },
    'calendar-jds_action_button': {
      kind: 'tertiary',
      size: 'medium',
      icon: 'ic_calendar'
    },
    jds_feedback_block: {
      size: 's',
      state: 'none'
    },
    'label-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      maxLines: 1
    },
    'helper-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    disabled: {
      true: {
        container: {
          opacity: '{i_38}',
          disabled: true
        },
        'dd-jds_input': {
          disabled: true
        },
        'mm-jds_input': {
          disabled: true
        },
        'yy-jds_input': {
          disabled: true
        },
        'calendar-jds_action_button': {
          disabled: true
        }
      }
    },
    error: {
      true: {
        jds_feedback_block: {
          state: 'error'
        },
        'dd-feedback-container': {
          'background-color': '{i_39}'
        },
        'mm-feedback-container': {
          'background-color': '{i_40}'
        },
        'yy-feedback-container': {
          'background-color': '{i_41}'
        }
      }
    },
    ddError: {
      true: {
        jds_feedback_block: {
          state: 'error'
        },
        'dd-feedback-container': {
          'background-color': '{i_42}'
        }
      }
    },
    mmError: {
      true: {
        jds_feedback_block: {
          state: 'error'
        },
        'mm-feedback-container': {
          'background-color': '{i_43}'
        }
      }
    },
    yyError: {
      true: {
        jds_feedback_block: {
          state: 'error'
        },
        'yy-feedback-container': {
          'background-color': '{i_44}'
        }
      }
    },
    showCalendar: {
      false: {
        'calendar-container': {
          hidden: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      disabled: {
        values: [false, true],
        doc_description: 'Determines the disabled input field'
      },
      error: {
        values: [false, true],
        doc_description: 'The error state of the input'
      },
      ddError: {
        values: [false, true]
      },
      mmError: {
        values: [false, true]
      },
      yyError: {
        values: [false, true]
      },
      showCalendar: {
        values: [true, false]
      }
    },
    data: {
      'dd-jds_input': {
        value: {
          type: 'number',
          name: 'ddValue'
        }
      },
      'mm-jds_input': {
        value: {
          type: 'number',
          name: 'mmValue'
        }
      },
      'yy-jds_input': {
        value: {
          type: 'number',
          name: 'yyValue'
        }
      },
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'errorText',
          doc_description: 'The error text to display'
        }
      },
      jds_datepicker: {
        open: {
          type: 'boolean',
          name: '_datepickerOpen'
        },
        offsetX: {
          type: 'string',
          name: '_offsetX'
        },
        offsetY: {
          type: 'string',
          name: '_offsetY'
        },
        triggerRef: {
          type: 'ref',
          name: 'triggerRef'
        },
        min: {
          type: 'date',
          name: 'min',
          doc_description: 'Defines the min date possible'
        },
        max: {
          type: 'date',
          name: 'max',
          doc_description: 'Defines the max date possible'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'Determines the label'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText',
          doc_description: 'The helper text to display'
        }
      }
    },
    events: {
      'calendar-jds_action_button': {
        onClick: 'onCalendarClick'
      },
      'dd-jds_input': {
        onChange: 'onDateChange',
        onSubmit: 'onDateSubmit',
        onKeydown: {
          name: 'onDateKeydown',
          platform: 'web'
        },
        onBlur: 'onDateBlur'
      },
      'mm-jds_input': {
        onChange: 'onMonthChange',
        onSubmit: 'onMonthSubmit',
        onKeydown: {
          name: 'onMonthKeydown',
          platform: 'web'
        },
        onBlur: 'onMonthBlur'
      },
      'yy-jds_input': {
        onChange: 'onYearChange',
        onSubmit: 'onYearSubmit',
        onKeydown: {
          name: 'onYearKeydown',
          platform: 'web'
        },
        onBlur: 'onYearBlur'
      },
      jds_datepicker: {
        onClose: 'onDatepickerClose',
        onSelect: 'onDatepickerSelect',
        onConfirm: 'onDatepickerSelect'
      }
    },
    a11y: {
      'dd-jds_input': {
        properties: {
          ariaLabel: {
            name: 'dateAriaLabel',
            value: 'Insert day'
          }
        }
      },
      'mm-jds_input': {
        properties: {
          ariaLabel: {
            name: 'monthAriaLabel',
            value: 'Insert month'
          }
        }
      },
      'yy-jds_input': {
        properties: {
          ariaLabel: {
            name: 'yearAriaLabel',
            value: 'Insert year'
          }
        }
      },
      'calendar-jds_action_button': {
        properties: {
          ariaLabel: {
            name: 'datepickerAriaLabel',
            value: 'Launch datepicker'
          }
        }
      }
    }
  }
};
